<template>
  <div style="width: fit-content">
    <div style="display: flex">
      <template v-for="(item, index) in upElementBlocks">
        <div v-if="item.name === 'customerDeliveryInfo'" :key="index" class="section form-column" :style="{width: item.width + 'px'}">
          <span class="title">{{ item.title }}</span>
          <div class="form-row" style="display:flex;flex-direction:column;">
            <slot v-for="elementName in item.elementNames" :name="elementName" />
          </div>
        </div>
        <div v-else :key="index" class="section form-column" :style="{width: item.width + 'px'}">
          <el-form label-width="105px" label-position="right">
            <span class="title">{{ item.title }}</span>
            <slot v-for="elementName in item.elementNames" :name="elementName" />
          </el-form>
        </div>
      </template>
    </div>
    <div v-if="downElementBlock && downElementBlock.name === 'customerDeliveryInfo'" class="section" style="width:100%">
      <span class="title">{{ downElementBlock.title }}</span>
      <div class="form-row" style="display:flex;flex-direction:row;margin-top:8px">
        <slot v-for="elementName in downElementBlock.elementNames" :name="elementName" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabAeBookingUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true }
  },
  computed: {
    upElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 1 && !p.hide)
    },
    downElementBlock() {
      return this.elementBlocks.find(p => p.position === 2 && !p.hide)
    }
  }
}
</script>
